// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-editor-selection-selectable__selectable:focus {\n  outline: none;\n}\n", "",{"version":3,"sources":["webpack://./src/editor/selection/selectable.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf","sourcesContent":[".selectable:focus {\n  outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectable": "src-editor-selection-selectable__selectable"
};
export default ___CSS_LOADER_EXPORT___;
